import React from 'react';
import { KatBox } from '@amzn/katal-react';

import './App.scss';

export class ScratchpadFooter extends React.Component<{region: string}> {

    constructor(props: Readonly<{ region: string; }>) {
        super(props);
    }

    getCustomerAgreement() {
        switch (this.props.region) {
            case "na":
                return (<a className="Scratchpad_footer_text" href="https://pay.amazon.com/help/201212430" target="_blank" rel="noopener noreferrer">Customer Agreement</a>);
            case "jp":
                return (<a className="Scratchpad_footer_text" href="https://pay.amazon.co.jp/help/201212430" target="_blank" rel="noopener noreferrer">Customer Agreement</a>);
            default:
               return(
                    <span className="Scratchpad_footer_text">
                        <a href="https://pay.amazon.eu/help/201212430" target="_blank" rel="noopener noreferrer">Amazon Payments Europe Agreement</a>
                        <br />
                        <a href="https://pay.amazon.eu/help/NPRHDT5HHB6S9YJ" target="_blank" rel="noopener noreferrer">Amazon Payments UK Agreement</a>
                    </span>
                );
        }
    }

    getPrivacyNotice() {
        switch (this.props.region) {
            case "na":
                return(<a className="Scratchpad_footer_text" href="https://pay.amazon.com/help/201751600" target="_blank" rel="noopener noreferrer">Privacy Notice</a>);
            case "jp":
                return(<a className="Scratchpad_footer_text" href="https://pay.amazon.co.jp/help/201212490" target="_blank" rel="noopener noreferrer">Privacy Notice</a>);
            default:
               return(
                    <span className="Scratchpad_footer_text">
                        <a href="https://pay.amazon.eu/help/201212490" target="_blank" rel="noopener noreferrer">Europe Privacy Notice</a>
                        <br />
                        <a href="https://pay.amazon.eu/help/201751600" target="_blank" rel="noopener noreferrer">UK Privacy Notice</a>
                    </span>
                );
        }
    }

    render() {
        return (
            <KatBox variant="zircon" className="Scratchpad_footer">
                {this.getCustomerAgreement()}
                {this.getPrivacyNotice()}
                <p className="Scratchpad_footer_text">©{new Date().getFullYear()} Amazon Payments, Inc. or its affiliates</p>
            </KatBox>
        );
    }
}

export default ScratchpadFooter;
